import { z } from 'zod';

export const registerSchema = z.object({
  first_name: z
    .string()
    .trim()
    .min(1, 'Voornaam is verplicht')
    .max(30, 'Voornaam mag maximaal 30 tekens bevatten')
    .regex(/^[A-Za-z ,.'-]+$/, 'Voornaam mag alleen letters bevatten'),
    
  last_name: z
    .string()
    .trim()
    .min(1, 'Achternaam is verplicht')
    .max(30, 'Achternaam mag maximaal 30 tekens bevatten')
    .regex(/^[A-Za-z ,.'-]+$/, 'Achternaam mag alleen letters bevatten'),

  company_name: z.string().trim().min(1, 'Bedrijfsnaam is verplicht'),

  company_slug: z
    .string()
    .trim()
    .min(1, 'Bedrijfs-URL is verplicht')
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, {
      message: 'Gebruik letters, cijfers en streepjes (bv. example-company)'
    }),

  company_registration: z
    .string()
    .trim()
    .min(1, 'Erkenningsnummer is verplicht')
    .refine(val => val.length === 4 || val.length === 5, {
      message: 'Erkenningsnummer moet 4 of 5 tekens bevatten'
    }),
  contact: z
    .string()
    .trim()
    .regex(/^[0-9+\-\s()]{8,}$/, 'Geef een geldig telefoonnummer'),

  email: z.email('Geef een geldig e-mailadres')
});

// Type helper
export type RegisterSchemaT = z.infer<typeof registerSchema>;

export const registerInitialValues = {
  last_name: '',
  first_name: '',
  company_name: '',
  company_slug: '',
  company_registration: '',
  contact: '',
  email: ''
};
